import { ReactNode } from "react";

import styles from "./MapFilterButton.module.scss";
import styled, { css } from "styled-components";

const Button = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 2.5rem;
  height: 2.5rem;
  margin-bottom: 0.5rem;
  background-color: var(--black-200);
  transition: background 0.4s;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);

  svg {
    width: 1.3125rem;
    height: 1.3125rem;

    path {
      stroke: var(--grey-100);
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      background-color: var(--primary);

      svg {
        path {
          stroke: var(--black-200);
        }
      }
    `}

  @media (min-width: 1400px) {
    width: 50px;
    height: 50px;

    svg {
      width: 25px;
      height: 25px;
    }
  }
`;

type Props = {
  icon?: ReactNode;
  selected?: boolean;
  tooltip?: string;
  onClick?: () => void;
};

function MapFilterButton({ icon, selected = false, onClick, tooltip }: Props) {
  return (
    <Button
      data-for="mapFilter"
      data-tip={tooltip}
      data-delay-show="1000"
      data-iscapture={true}
      onClick={onClick}
      isActive={selected}
    >
      {icon}
    </Button>
  );
}

export { MapFilterButton };
